import PropTypes from 'prop-types';
import React from 'react';

const BankNameInput = (props) => {
  return (
    <div>
      {props.inputUseBar && (
        <input
          data-aut-test="input-select-bank-name-send"
          data-testid="input-select-bank-name-send"
          className="input-bank-message"
          type="text"
          name="message"
          id="message"
          autoComplete="off"
          value={props.value}
          onChange={props.onChange}
          onClick={props.onClickResetBankSelected}
        />
      )}
      {!props.inputUseBar && (
        <input
          data-aut-test="input-select-bank-name"
          data-testid="input-select-bank-name"
          className="input-bank-message"
          type="text"
          name="message"
          id="message"
          autoComplete="off"
          placeholder={
            props.banksList.length > 0
              ? 'Digite o nome ou código do banco de sua preferência'
              : props.boxInformation
          }
          value={props.banksList.length > 0 ? props.bankName : ''}
          disabled={props.banksList.length > 0 ? '' : 'disabled'}
          onChange={(e) => props.onChangeBankName(e.target.value)}
        />
      )}
    </div>
  );
};

BankNameInput.propTypes = {
  value: PropTypes.string,
  boxInformation: PropTypes.string,
  inputUseBar: PropTypes.bool,
  banksList: PropTypes.array,
  onClickResetBankSelected: PropTypes.func,
  onChangeBankName: PropTypes.func,
  onChange: PropTypes.func,
  bankName: PropTypes.string
};

export default BankNameInput;
